import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { FaLocationDot } from "react-icons/fa6";
import styles from "./PhysicianView.module.scss";
import maleImg from "../../../images/CCImages/PhysicianImageMale.png";
import femaleImg from "../../../images/CCImages/PhysicianImageFemale.png";

const PhysicianView = ({ physician, show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Physician Details</Modal.Title>
      </Modal.Header>
      <Modal.Body >
        {physician && (
          <div className={styles['physician-view']}>
            <Row>
              <Col md={4}>
                <div className={styles['physician-img']}>
                  <img
                     src={physician?.userId?.gender === "Male" ? maleImg : femaleImg}
                    alt={physician?.userId?.name}
                    className="img-fluid rounded-circle"
                  />
                </div>
              </Col>
              <Col md={8}>
                <div className={styles['physician-details']}>
                  <h4>{physician?.userId?.name}</h4>
                  <p className={styles['physician-specialization']}>
                    Specialization: {physician?.specialization?.specialization}
                  </p>
                  <p className={styles['physician-location']}>
                    <FaLocationDot /> {physician?.userId?.address}
                  </p>
                  <p className={styles['physician-email']}>
                    Email: {physician?.userId?.email}
                  </p>
                  <p className={styles['physician-phone']}>
                    Phone: {physician?.userId?.phone}
                  </p>
                  {/* Add more physician details as needed */}
                </div>
              </Col>
            </Row>
          </div>        
        )}
      </Modal.Body>

    </Modal>
  );
};

export default PhysicianView;
